$( document ).ready(function() {
    var initEditor = function() {
        tinymce.init({
            selector: '#cms-content',
            height : "480",
            plugins: 'image code link lists preview table',
            toolbar: "insertfile a11ycheck undo redo | bold italic | forecolor backcolor | template codesample | alignleft aligncenter alignright alignjustify | bullist numlist | table | link image | preview",
            file_picker_types: 'image',
            automatic_uploads: true,
            image_description: false,
            images_upload_handler: function (blobInfo, success, failure) {
                var data = new FormData();
                data.append('file', blobInfo.blob());

                $.ajax({
                    url: $('body').data('base-url') + 'cms/upload',
                    type: 'POST',
                    data: data,
                    contentType: false,
                    processData: false,
                    success: function (responseTxt) {
                        var res = JSON.parse(responseTxt);
                        if (res.success) {
                            success($('body').data('cdn-url') + res.dir);
                        }
                    }
                });
            }
        });
    };

    var initSlugCalculator = function() {
        var fillSlug = function(obj) {
            $('.pages').find('[name=slug]').val(obj.val().toLowerCase().trim().replace(/\s/g,"-"));
            $('.pages').find('[name=slug]').prev().addClass('active');
        };

        $('.pages').find('[name=title]').keyup(function(){
            fillSlug($(this));
        });

        $('.pages').find('[name=title]').focusout(function(){
            fillSlug($(this));
        });
    };

    initEditor();
    initSlugCalculator();
});